import React, { useState } from 'react';
import pcFoto from '../../images/macbooknopainel.png';
import integracoesFoto from '../../images/integracoes.png';
import sublinhado from '../../images/sublinhado.png';
import sublinhado2 from '../../images/sublinhado2.png';
import robotexto from '../../images/robotexto.png';
import prancheta from '../../images/prancheta.png';
import { Box, Button, Grid, MenuItem, Modal, Stack, TextField, Typography, useTheme } from '@mui/material';
import useResponsive from '../../services/useReponsive';
import { useNavigate, useParams } from 'react-router-dom';

const Contratar = () => {
    const isMobile = useResponsive();
    const theme = useTheme();
    const [isContratarModalOpen, setContratarModalOpen] = useState(false);
    const [corridasPorMes, setCorridasPorMes] = useState('');
    const cupom = useParams().cupom;

    const navigate = useNavigate();

    const handleOpenContratarModal = () => setContratarModalOpen(true);
    const handleCloseContratarModal = () => setContratarModalOpen(false);

    const handleCorridasChange = (event) => setCorridasPorMes(event.target.value);
    const handleConfirmContratar = () => navigate(`/assinar/plano${corridasPorMes}/${cupom}?`);

    return (
        <Box
            sx={{
                maxWidth: isMobile ? '400px' : '100%',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                backgroundColor: theme.palette.background.default,
                padding: '16px',
            }}
        >
            <Grid container spacing={4} sx={{ maxWidth: '1200px', width: '100%' }}>
                <Grid item xs={12}>
                    <Stack
                        direction={isMobile ? 'column' : 'row'}
                        alignItems="center"
                        justifyContent="space-between"
                        spacing={4}
                        sx={{ textAlign: isMobile ? 'center' : 'left' }}
                    >
                        <Typography variant="h4" fontWeight="bold">
                            Gerencie suas entregas e entregadores sem estresse!
                            <Typography variant="body1" sx={{ marginTop: '8px' }}>
                                Conheça nossos benefícios para otimizar seu delivery.
                            </Typography>
                        </Typography>
                        <img
                            src={pcFoto}
                            alt="Computador"
                            style={{
                                width: isMobile ? '100%' : '50%',
                                maxWidth: '400px',
                                height: 'auto',
                            }}
                        />
                    </Stack>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h3" textAlign="center" fontWeight="bold" marginBottom={4}>
                        Conheça nossas{' '}
                        <Typography variant="span" color="primary">
                            integrações
                        </Typography>
                    </Typography>
                    <Stack
                        direction={isMobile ? 'column' : 'row'}
                        alignItems="center"
                        justifyContent="center"
                        spacing={4}
                    >
                        <img
                            src={integracoesFoto}
                            alt="Integrações"
                            style={{
                                width: '100%',
                                maxWidth: '500px',
                                height: 'auto',
                            }}
                        />
                        <Typography variant="h5" color={theme.palette.grey[600]} textAlign="center">
                            Seu delivery conectado! A Pick integra com as melhores do mercado, facilitando a vida dos
                            seus atendentes e agilizando pedidos.
                        </Typography>
                    </Stack>
                </Grid>

                <Grid item xs={12}>
                    <Typography
                        variant="h3"
                        textAlign="center"
                        sx={{
                            display: 'inline-block',
                            position: 'relative',
                            '&::after, &::before': {
                                content: '""',
                                position: 'absolute',
                                width: '50%',
                                height: '20px',
                                bottom: '-10px',
                                backgroundSize: 'contain',
                            },
                            '&::after': {
                                background: `url(${sublinhado}) no-repeat`,
                                left: 200,
                            },
                            '&::before': {
                                background: `url(${sublinhado2}) no-repeat`,
                                right: 220,
                                transform: 'scaleX(-1)',
                            },
                            '@media (max-width: 600px)': {
                                '&::after, &::before': {
                                    display: 'none',
                                },
                            },
                        }}
                    >
                        Roteirize automaticamente suas rotas
                    </Typography>

                </Grid>

                <Grid item xs={12}>
                    <Stack direction={isMobile ? 'column' : 'row'} spacing={4} alignItems="center">
                        <Typography variant="h4" textAlign={isMobile ? 'center' : 'left'} fontWeight="bold">
                            Sofrendo com atraso nos pedidos? Temos a solução.
                            <Typography
                                variant="body1"
                                sx={{ marginTop: '8px', color: theme.palette.grey[600] }}
                            >
                                Um robô criado para programar facilmente o despacho automático dos seus pedidos, aliado
                                a uma tecnologia que roteiriza o melhor caminho para seu entregador.
                            </Typography>
                        </Typography>
                        <img
                            src={robotexto}
                            alt="Robô"
                            style={{
                                width: '100%',
                                maxWidth: '400px',
                                height: 'auto',
                            }}
                        />
                    </Stack>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h3" textAlign="center" marginBottom={4}>
                        Quer saber mais?
                    </Typography>
                    <Box sx={{ width: '100%', maxWidth: '700px', margin: '0 auto', mb: 4 }}>
                        <iframe
                            style={{
                                width: '100%',
                                aspectRatio: '16/9',
                                borderRadius: '8px',
                                overflow: 'hidden',
                            }}
                            src="https://youtube.com/embed/Jjk16bRtHTY"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </Box>
                </Grid>
            </Grid>

            <Box
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    zIndex: 1500,
                    mb: 2,
                }}
            >
                <Button
                    variant="contained"
                    sx={{
                        maxWidth: '300px',
                        width: '100%',
                        color: 'white',
                    }}
                    onClick={handleOpenContratarModal}
                >
                    Contratar
                </Button>
            </Box>

            {/* Modal */}
            <Modal
                open={isContratarModalOpen}
                onClose={handleCloseContratarModal}
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
                <Box
                    sx={{
                        width: '90%',
                        maxWidth: '400px',
                        padding: 4,
                        backgroundColor: 'white',
                        borderRadius: 2,
                        boxShadow: theme.shadows[5],
                    }}
                >
                    <Typography variant="h6" textAlign="center" marginBottom={2}>
                        Quantas corridas você faz por mês?
                    </Typography>
                    <TextField
                        select
                        size="small"
                        label="Corridas por mês"
                        value={corridasPorMes}
                        onChange={handleCorridasChange}
                        sx={{ width: '100%', mb: 2 }}
                    >
                        <MenuItem value="">Selecione...</MenuItem>
                        <MenuItem value={500}>Até 500 corridas</MenuItem>
                        <MenuItem value={1000}>Até 1000 corridas</MenuItem>
                        <MenuItem value={1500}>Até 1500 corridas</MenuItem>
                        <MenuItem value={2000}>Até 2000 corridas</MenuItem>
                        <MenuItem value={3000}>Até 3000 corridas</MenuItem>
                        <MenuItem value={4000}>Até 4000 corridas</MenuItem>
                        <MenuItem value={5000}>Até 5000 corridas</MenuItem>
                        <MenuItem value={8000}>Até 8000 corridas</MenuItem>
                        <MenuItem value={10000}>Até 10000 corridas</MenuItem>
                    </TextField>
                    <Button
                        variant="contained"
                        fullWidth
                        disabled={!corridasPorMes}
                        onClick={handleConfirmContratar}
                        sx={{ color: 'white' }}
                    >
                        Confirmar
                    </Button>
                </Box>
            </Modal>
        </Box>
    );
};

export default Contratar;
